import React from 'react';
import { FaArrowRight, FaDownload } from 'react-icons/fa';
import portfolioConfig from '../../config/portfolioConfig';

const CTA = () => {
  const { personal } = portfolioConfig;

  return (
    <div className="cta">
      <a href="#portfolio" className="btn btn-primary">
        View selected work <FaArrowRight />
      </a>
      <a
        href={personal.cv}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-secondary"
      >
        Download CV <FaDownload />
      </a>
    </div>
  );
};

export default CTA;
